/** @format */

import React from 'react';

export const LOGIN_STEP = 1; //is located in the login page, thus starting from 2
export const SHIPPING_STEP = 2;
export const BILLING_STEP = 3;
export const PAYMENT_STEP = 4;

const CartCheckoutContextDefault = {
    agreedToTerms: false,
    showTerms: true,
    currentStep: SHIPPING_STEP,
    combinedCartCount: 0, // When orders are autocombined, how many?
    validationErrors: {}, // errors for validation
    purchasing: false, // Are we making this official?
    creditLimit: '',
    loading: true,
    saving: false, // Are we updating anything on the cart?
    addresses: [], // Addresses saved on this user's account
    countries: [],
    shipments: [],
    orders: [], // Orders in this cart
    states: [],
    unpaid: [],
    cart: {
        is_shipping_when_ready: false,
        billing_account_last_four: '',
        shipping_method_provider: '',
        billing_account_type_id: '',
        is_blind_shipping: false,
        shipping_method_name: '',
        shipping_method_code: '',
        is_shipping_free: false,
        shipping_address_id: '',
        billing_address_id: '',
        payment_profile_id: '',
        billing_method_id: '',
        is_tax_exempt: false, // This is set when the cart is created in the cartsTable
        discount_amount: '',
        is_reorder: false,
        package_count: '', // How many packages is this estimated to be split into
        order_count: '', // Numer of orderes in the cart
        discount_id: '',
        status_id: '',
        po_number: '', // Customer supplied tracking number
        shipping: '', // Shipping costs
        subtotal: '', // Labels + Options (does not include shipping, tax, duties, discounts
        user_id: '',
        duties: '', // Internaltional Taxes
        weight: '', // The calculated weight of the orders
        total: '', // All the things summed up
        tax: '' // Tax costs
    },
    onPurchase: () => {
        console.log(`context default onPurchase`);
    },
    onChange: () => {
        console.log(`context default onChange`);
    },
    onUpdateWithoutSave: () => {
        console.log(`context default onUpdateWithoutSave`);
    },
    onSave: () => {
        console.log(`context default onSave`);
    },
    onSetCurrentStep: () => {
        console.log(`context default onSetCurrentStep`);
    },
    isStepComplete: () => {
        console.log(`context default isStepComplete`);
        return false;
    }
};
const CartCheckoutContext = React.createContext(CartCheckoutContextDefault);

export {CartCheckoutContext, CartCheckoutContextDefault};
